import { CLIENT_APPLY, FORGOT_PASSWORD, LOGIN } from './routes'
import Login from '../views/Login/Login'
import ForgotPassword from '../views/Login/ForgotPassword'
import ContactRegister from '../views/Login/ContactRegister'

export const authRoutes = [
  { path: LOGIN, element: <Login /> },
  { path: FORGOT_PASSWORD, element: <ForgotPassword /> },
  { path: CLIENT_APPLY, element: <ContactRegister /> },
  //{ path: REGISTER, element: <Login /> }
]
